// extracted by mini-css-extract-plugin
export var borderRadius = "_az-4";
export var large = "_az-3";
export var logoContainer = "_az-0";
export var nameLogo = "_az-2";
export var small = "_az-1";